import script from "./GiftPyramidTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftPyramidTable.vue?vue&type=script&setup=true&lang=js"

import "./GiftPyramidTable.vue?vue&type=style&index=0&id=3472cb70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3472cb70"]])

export default __exports__